import * as auth from './auth'
import * as apicalls from './apicalls'
export default {
    ...auth,
    ...apicalls
}